import { useIsDesktop } from 'hooks/responsive';

export default function WhenDesktop({ negate = false, children }) {
    const value = useIsDesktop();

    if (negate) return value ? null : children;

    return value ? children : null;
}
